<template>
  <div class="h-full" ref="container" />
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, watch } from 'vue'
import * as monaco from 'monaco-editor'

const props = defineProps<{
  original: string
  modified: string
  language?: string
}>()

const container = ref<HTMLElement>()
let diffEditor: monaco.editor.IStandaloneDiffEditor | null = null

onMounted(() => {
  diffEditor = monaco.editor.createDiffEditor(container.value!, {
    theme:            'craft-dark',
    automaticLayout:  true,
    readOnly:         true,
    renderSideBySide: true,
  })
  setModels(props.original, props.modified, props.language)
})

watch([() => props.original, () => props.modified, () => props.language], ([orig, mod, lang]) => {
  setModels(orig, mod, lang)
})

function setModels(original: string, modified: string, language?: string): void {
  if (!diffEditor) return
  const prev = diffEditor.getModel()

  const lang = language ?? 'plaintext'
  diffEditor.setModel({
    original: monaco.editor.createModel(original, lang),
    modified: monaco.editor.createModel(modified, lang),
  })

  // Dispose previous models to prevent unbounded memory growth.
  prev?.original.dispose()
  prev?.modified.dispose()
}

onUnmounted(() => {
  const model = diffEditor?.getModel()
  model?.original.dispose()
  model?.modified.dispose()
  diffEditor?.dispose()
  diffEditor = null
})
</script>
